import { useState, useEffect } from 'react'
import { collection, getDocs, query, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase/config'

export const useStats = () => {
  const [stats, setStats] = useState({
    sitesCount: 0,
    researchersCount: 0,
    mediaCount: 0,
    loading: true,
    error: null
  })

  useEffect(() => {
    // Set loading state
    setStats(prev => ({
      ...prev,
      loading: true
    }))

    // Create real-time listeners for each collection
    const unsubscribes = []
    
    // Sites listener
    const sitesUnsubscribe = onSnapshot(
      collection(db, 'sites'),
      (snapshot) => {
        setStats(prev => ({
          ...prev,
          sitesCount: snapshot.size,
          loading: false
        }))
      },
      (error) => {
        console.error('Error in sites listener:', error)
        setStats(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to load stats'
        }))
      }
    )
    unsubscribes.push(sitesUnsubscribe)
    
    // Users listener
    const usersUnsubscribe = onSnapshot(
      collection(db, 'users'),
      (snapshot) => {
        setStats(prev => ({
          ...prev,
          researchersCount: snapshot.size,
          loading: false
        }))
      },
      (error) => {
        console.error('Error in users listener:', error)
        setStats(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to load stats'
        }))
      }
    )
    unsubscribes.push(usersUnsubscribe)
    
    // Media listener
    const mediaUnsubscribe = onSnapshot(
      collection(db, 'site_media'),
      (snapshot) => {
        setStats(prev => ({
          ...prev,
          mediaCount: snapshot.size,
          loading: false
        }))
      },
      (error) => {
        console.error('Error in media listener:', error)
        setStats(prev => ({
          ...prev,
          loading: false,
          error: 'Failed to load stats'
        }))
      }
    )
    unsubscribes.push(mediaUnsubscribe)
    
    // Cleanup function to unsubscribe from all listeners
    return () => {
      unsubscribes.forEach(unsubscribe => unsubscribe())
    }
  }, [])

  return stats
}
